import React from "react";
import Actor from "./Actor";

function TownTitlesTabContent(props) {
  const { town: townProp } = props;

  const town = React.useMemo(() => {
    return townProp.entity;
  }, [townProp]);

  return React.useMemo(() => {
    return town.titles.all.map((title) => {
      return (
        <div key={`key-${title.name}`}>
          <h4 className="TabsContentTitle">
            <Actor type="town-title" actorID={title.id} />
          </h4>
          <p>
            {title.holder == null ? (
              <center>N/A</center>
            ) : (
              <Actor type="adventurer" actorID={title.holder.id} />
            )}
          </p>
        </div>
      );
    });
  }, [town]);
}

export default React.memo(TownTitlesTabContent);
